import type { OfficeConfig, OfficeProvider } from '../../interfaces/OfficeConfig';

export interface OfficeConfigSlice {
  officeConfig: OfficeConfig | null;
  officeProvider: OfficeProvider | null;
  setOfficeConfig: (config: OfficeConfig) => void;
}

export const createOfficeConfigSlice = (set: any, _: any): OfficeConfigSlice => ({
  officeConfig: null,
  officeProvider: null,
  setOfficeConfig: (config) =>
    set({
      officeConfig: config,
      officeProvider: config.provider,
    }),
});
